module.exports = __webpack_public_path__ + "static/falling-coins-3e15ded3c246342eff2cdfd2872e6211.jpg";